import React from 'react';
import { Avatar, Card, Table, Progress, Typography, Space, Tag, Row } from 'antd';
import Logo from "../../../Components/Graphics/Logo";
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import MorningstarStylebox from "../../../Components/Stylebox/MorningstarStylebox";
import {iconMapping} from "../../../Configs/AppsConfig";
import {stringMixin} from "../../../utils/strings";
import TickerChip  from "../../../Components/TickerChip";
import {DoubleLine} from "../../../Components/Labels";
const { Title } = Typography;



const tableColumns = [
    {
      title: '',
      dataIndex: 'logo',
      key: 'logo',
      render: (text, record)=><TickerChip ticker={record} />
    },
    {
      title: 'Weight (%)',
      dataIndex: 'weight',
      key: 'weight',
      render: weight => <Progress
          type={'dashboard'}
          size={'small'}
          percent={parseFloat((weight).toFixed(1))}
          status="active"
      />, // This assumes `weight` is a percentage value.
    },
    {
        title: "Categories",
        dataIndex: 'categories',
        key: 'categories',
        render: (text, record)=><DoubleLine title={record?.tags?.sector} text={record?.tags?.industry}/>
    },
    {
      title: "Stylebox",
      render: (record)=> {
          const size = record?.tags?.size;
          const style = record?.tags?.style;
          if (size && style) {
              return <MorningstarStylebox styles={[`${size}_${style}`]} showLabels={false} />
          }
          return '';
      },
      align: 'center'
    },
    {
        title: "Corr S&P (1Y)",
        dataIndex:  ['stats', 'benchmarks', 'spy', 'corr_1_yr'],
        key: 'corr',
        render: (text)=>stringMixin.pct(text),
        sorter: (a, b) => a?.stats?.benchmarks?.spy?.corr_1_yr - b?.stats?.benchmarks?.spy?.corr_1_yr,
    }
];


const TickerTable = ({ tickers }) => {
    tickers.sort((a, b) => b.weight - a.weight);

    const etfTickers = tickers.filter(ticker => ticker.type === 'etf');

  return (
      <Card
        bordered={false}
      >
        <Row justify={'start'}>
            <ButtonGroup size={'small'}>
                <Button size={'small'}
                        variant={'outlined'}
                        onClick={()=>window.open(`/public/etfs/matrix?etfs=${etfTickers.map(x=>x.symbol).join(',')}`)}
                        startIcon={<Avatar className={'mx-1 mb-1'} src={iconMapping.positions}/>}
                >
                    View ETF Matrix
                </Button>
                <Button size={'small'} variant={'contained'}>
                    Compare {tickers.length} Holdings
                </Button>
            </ButtonGroup>
        </Row>
        <Table
          className={'spaced'}
          columns={tableColumns}
          dataSource={tickers}
          rowKey="symbol"
          pagination={false} // Disable pagination if not needed
          scroll={{ x: true }} // Makes table scrollable horizontally
        />
      </Card>
  )

};

export default TickerTable;